// extracted by mini-css-extract-plugin
export default {"modalBody":"Voucher_modal_modalBody__R4s0q","infoText":"Voucher_modal_infoText__F8YqM"};